import React from "react";
import PropTypes from "prop-types";
import { RichText, Date } from "prismic-reactjs";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import style from "./style";
import { useRouter } from 'next/router'
import PersonItem from "../../components/PersonItem";
import TitleSubtitle from "../../components/TitleSubtitle";
import CustomLink from "../../components/CustomLink";
import { useLayout } from "../../utils/layout-context";
const dateOptions = {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric",
};

const FeaturedBlogsInProjects = ({
  classes,
  allBlogsBasedOnProjectCategory,
}) => {
  const { layout } = useLayout();
  return (
    <div className={classes.featuredBlogs}>
      <Container maxWidth="lg">
        <TitleSubtitle
          title={
            layout && RichText.asText(layout.related_stories_section_title)
          }
          subtitle={
            layout && RichText.asText(layout.related_stories_section_subtitle)
          }
          showClass
        />
        {allBlogsBasedOnProjectCategory && (
          <Grid
            container
            spacing={4}
            direction="row"
            justify="center"
            className="featureBlogsContainer"
          >
            {allBlogsBasedOnProjectCategory &&
              allBlogsBasedOnProjectCategory.slice(0, 3).map((blog, index) => {
                return (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <PersonItem
                      link={blog}
                      showTag={
                        blog.data.project_categories &&
                        blog.data.project_categories.length > 0
                      }
                      tag={
                        blog.data.blog_topics &&
                        blog.data.blog_topics.length > 0 ? (
                          <CustomLink
                            link={blog.data.blog_topics[0].blog_topic}
                          >
                            {RichText.asText(
                              blog.data.blog_topics[0].blog_topic.data
                                .topic_name
                            )}
                          </CustomLink>
                        ) : null
                      }
                      bannerImageSrc={blog.data.featured_image.url}
                      bannerImageAlt={blog.data.featured_image.alt}
                      name={RichText.asText(blog.data.title)}
                      title={Date(blog.data.date).toLocaleDateString(
                        useRouter().locale,
                        dateOptions
                      )}
                    />
                  </Grid>
                );
              })}
          </Grid>
        )}
        <Grid container direction="row" justify="center" alignItems="center">
          {layout && (
            <CustomLink link={layout.related_stories_section_button_link}>
              <Button variant="outlined">
                {RichText.asText(layout.related_stories_section_button_text)}
              </Button>
            </CustomLink>
          )}
        </Grid>
      </Container>
    </div>
  );
};

FeaturedBlogsInProjects.propTypes = {
  classes: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withStyles(style)(FeaturedBlogsInProjects);
